import './IonIcon.scss'
import React from 'react'

const IonIcon = ({ icon }) => {
  return (
    <i className={`IonIcon ion ion-${icon}`} />
  )
}

IonIcon.displayName = 'IonIcon'

export default IonIcon



// WEBPACK FOOTER //
// ./src/lib/IonIcon.js